import { render, staticRenderFns } from "./manual_payment.vue?vue&type=template&id=2b392975&scoped=true&"
import script from "./manual_payment.vue?vue&type=script&lang=js&"
export * from "./manual_payment.vue?vue&type=script&lang=js&"
import style0 from "./manual_payment.vue?vue&type=style&index=0&id=2b392975&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b392975",
  null
  
)

export default component.exports